import React, { useEffect, useState } from 'react';
import ORBApi from '../../services/ORBApi';
import { Select, InputLabel, FormControl } from '@mui/material';

export default function AgentsDropdown({
  value,
  onChange,
  className,
  hideEmpty,
  margin,
  label,
  error
}) {
  const [agents, setAgents] = useState([]);
  const [selected, setSelected] = useState('');

  useEffect(() => {
    setSelected(value);
  }, [value]);

  useEffect(() => {
    // Load all agents when the component mounts (page_size = 0 => sem paginação)
    ORBApi.loadAgents(1, null, 0, 'name', 'asc').then((response) => {
      const list = response?.agents || [];
      const sortedAgents = [...list].sort((a, b) => {
        return a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' });
      });
      setAgents(sortedAgents);
    });
  }, []);

  const onChangeHandler = (e) => {
    setSelected(e.target.value);
    onChange(e.target.selectedOptions[0].getAttribute('agent_id'));
  };

  return (
    <FormControl
      fullWidth
      margin={margin}
      variant="outlined"
      className={className}
      error={error}
    >
      <InputLabel shrink={selected > 0}>{label}</InputLabel>
      <Select
        native
        label={label}
        onChange={onChangeHandler}
        value={selected}
        notched={selected > 0}
      >
        {!hideEmpty ? <option value="" /> : null}
        {agents.map((agent) => {
          return (
            <option key={agent.id} value={agent.id} agent_id={agent.id}>
              {agent.name}
            </option>
          );
        })}
      </Select>
    </FormControl>
  );
}
